import React from 'react'
import {Tag} from "antd"

import { capitalized } from '../../../../utils/util';

function TagItemTypes(props) {
    let value = 'green';
    if( props.data === 'Finished Goods' ) value = 'green'
    else if( props.data === 'Finish Goods' ) value = 'green'
    else if( props.data === 'Ingredients' ) value = 'geekblue'
    else if( props.data === 'Work Instruction' ) value = 'gold'
    else if( props.data === 'Packing Goods' ) value = 'blue'
    else if( props.data === 'Raw Material' ) value = 'red'
    else if( props.data === 'Packing' ) value = 'purple'
    else if( props.data === 'Packaging' ) value = 'orange'
    else value = 'volcano'

    return (
      <div>
        { <Tag color={value} >{capitalized(props.data || "")}</Tag> }
      </div>
    )
} 

export default TagItemTypes
